const stickyAlertBannerTop = {
  attachListeners: function () {
    this.alertSticky();
    this.alertStickyClose();
  },

  init: function () {
    document.addEventListener("DOMContentLoaded", () => {
      this.attachListeners();
    });
  },

  alertSticky: function () {
    if ($(".sticky-alert-banner-top").is(":visible")) {
      $(".header").addClass("class-for-alert");
      $("main").addClass("class-for-alert-main");
    }
  },
  alertStickyClose: function () {
    $(".sticky-alert-banner-top .btn-close").on("click", function (e) {
      e.preventDefault();
      $(".header").removeClass("class-for-alert");
      $("main").removeClass("class-for-alert-main");
    });
  },
};

window.stickyAlertBannerTop = stickyAlertBannerTop;
window.stickyAlertBannerTop.init();

const testScrollTop = {
  attachListeners: function () {
    this.scrollTop();
  },

  init: function () {
    window.addEventListener("load", () => {
      this.attachListeners();
    });
  },

  scrollTop: function () {
    // Load
    setScrollElem();
    // On Change hash on url
    window.addEventListener("hashchange", function () {
      setScrollElem();
    });

    // Trigger Click on Anchor
    if (window.location.hash) {
      $("a").on("click", function () {
        var href = $(this).attr("href");
        var id = $("body").find(href);
        setTimeout(() => {
          window.scrollTo(0, $(id).offset().top - 200);
        }, 10);
      });
    }

    function setScrollElem() {
      var $el,
        url_hash = window.location.hash;
      if (url_hash) {
        $el = $(url_hash);
        if ($el.length) {
          setTimeout(() => {
            window.scrollTo(0, $el.offset().top - 200);
          }, 10);
        }
      }
    }
  },
};

window.testScrollTop = testScrollTop;
window.testScrollTop.init();

const mobileMenu = {
  attachListeners: function () {
    this.openMobileMenu();
    this.resizeMobileMenu();
  },

  init: function () {
    document.addEventListener("DOMContentLoaded", () => {
      this.attachListeners();
    });
  },

  openMobileMenu: function () {
    $(".js-open-nav-mobile").on("click", function (e) {
      e.preventDefault();
      $(".js-nav-mobile").addClass("class-width-mobile");
    });

    $(".js-close-nav-mobile").on("click", function (e) {
      e.preventDefault();
      $(".js-nav-mobile").removeClass("class-width-mobile");
    });
  },

  resizeMobileMenu: function () {
    $(window).on("resize orientationchange", function () {
      if ($(window).width() > 899) {
        $(".js-nav-mobile").removeClass("class-width-mobile");
      }
    });
  },
};

window.mobileMenu = mobileMenu;
window.mobileMenu.init();

const desktopMenu = {
  attachListeners: function () {
    this.desktopMenuUnderline();
  },

  init: function () {
    document.addEventListener("DOMContentLoaded", () => {
      this.attachListeners();
    });
  },

  desktopMenuUnderline: function () {
    if ($(".nav-primary .nav-link.active").length) {
      $(".nav-link.active").parent().addClass("active-underline");
    } else {
      $(".nav-link.active").parent().removeClass("active-underline");
    }
  },
};

window.desktopMenu = desktopMenu;
window.desktopMenu.init();

const mainStyleController = {
  attachListeners: function () {
    this.checkHeaderForNavSecondary();
  },

  init: function () {
    document.addEventListener("DOMContentLoaded", () => {
      this.attachListeners();
    });
  },

  checkHeaderForNavSecondary: function () {
    const header = document.querySelector("header");
    const main = document.querySelector("main");

    if (header && header.querySelector(".nav-secondary")) {
      main.classList.add("nav-secondary-main");
    } else {
      main.classList.remove("nav-secondary-main");
    }
  },
};

window.mainStyleController = mainStyleController;
window.mainStyleController.init();
